import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { distanceRadiusInKmSelector } from '../../../store/modules/filters/selectors';
import { filtersSliceActions } from '../../../store/modules/filters/reducer';
import Slider from '../../../../../../../../global/react-mui/atoms/Slider';
import useDebouncedCallback from 'global/react/hooks/useDebounceCallback';
import { partnerProfileDrawerIsOpenSelector } from '../../../store/modules/ui/selectors';
import { mapSliceActions } from '../../../store/modules/map/reducer';

const RangeSlider: React.FC<Record<string, unknown>> = () => {
	const dispatch = useDispatch();
	const distanceRadiusInKm = useSelector(distanceRadiusInKmSelector);
	const setDistanceRadiusInKm = (_, value) => dispatch(filtersSliceActions.setDistanceRadiusInKm(value));
	const handleSetDistanceRadiusInKm = useDebouncedCallback(setDistanceRadiusInKm, 200);
	const shouldBeDisabled = useSelector(partnerProfileDrawerIsOpenSelector);

	return (
		<Slider
			handleOnChange={handleSetDistanceRadiusInKm}
			id="range-slider"
			step={5}
			defaultValue={25}
			label={`Entfernung: ${distanceRadiusInKm}km`}
			disabled={shouldBeDisabled}
		/>
	);
};

export default RangeSlider;
